import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

import Layout from '../../shared/components/layouts/MainLayout';
import TextInput from '../../shared/components/forms/TextInput';
import TimedBanner from '../../shared/components/notices/TimedBanner';
import {fetchCompany, updateCompany} from '../actions';
import {segmentEventTracker} from '../../../utils/SegmentEventTracker';
import {
  TrackEventName,
  PageViewName,
} from '../../shared/constants/SegmentEvents';

class CompanyInformation extends Component {
  constructor(props) {
    super(props);

    const {company_name} = this.props.company_info;

    this.state = {
      data: Object.assign({}, {company_name}),
    };

    this.banner = React.createRef();
  }

  componentDidMount() {
    this.props.fetchCompany();
    segmentEventTracker.trackPageView(PageViewName.COMPANY_INFORMATION_VIEWED);
  }

  onChange = e => {
    const input = e.target;
    const name = input.name;
    const value = input.value;
    const data = Object.assign({}, this.state.data, {[name]: value});
    this.setState({data: data});
  };

  onSubmit = () => {
    segmentEventTracker.trackEvent(
      TrackEventName.SAVE_CHANGES_COMPANY_NAME_CLICKED,
    );
    // TODO: handle error/success states in actions through redux
    // apply in phase 7
    this.props.updateCompany(this.state.data, response => {
      this.banner.current.show();
    });
  };

  render() {
    return (
      <Fragment>
        <TimedBanner body="Company updated!" className="-success" ref={this.banner} />
        <Layout header="Company Information">

          <div className="ds-card">
            <section className="cardSection">
              <TextInput
                label="Company Name"
                name="company_name"
                value={this.state.data.company_name}
                onChange={this.onChange}
                tip="Please enter the full name as it appears on any official documentation."
              />
            </section>
            <button
              data-testid="save-button"
              className="ds-btn --full"
              onClick={this.onSubmit}>
              Save
            </button>
          </div>
        </Layout>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    company_info: state.company,
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    fetchCompany: () => dispatch(fetchCompany()),
    updateCompany: (body, callback) => dispatch(updateCompany(body, callback)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CompanyInformation),
);



// WEBPACK FOOTER //
// ./src/features/company/containers/CompanyInformation.js